export default "__VITE_ASSET__DATEgqyR__"